<!--
 * @Description: 隐私政策
 * @Author: hanyu
 * @Date: 2020-05-29 08:39:22
 * @LastEditTime: 2020-10-22 11:17:17
 * @LastEditors: 李云飞
-->
<template>
  <div>
    <AgreementHeader></AgreementHeader>
    <div class="wrapper">
      <ColumnName en-name="RENMINYIXUEWANGYINSITIAOKUAN"
        cn-name="隐私条款"></ColumnName>
    </div>
    <div class="txt-box">
      <p class="title">
        引言
      </p>
      <p class="txt">
        {{getCompanyName}}（以下统称"我们"）非常重视用户的隐私和个人信息保护。本协议通过适用移动客户端以及pc端和其他方式使用{{getCompanyName}}服务的用户（以下简称“用户”或“您”），与本公司共同缔结。您在使用下载、开启、浏览、注册、登录我们的产品和服务时，我们可能会收集和使用您的相关信息。我们希望通过用户隐私权保护条款（以下简称“本政策”或“隐私条款”）向您说明在您接受我们的产品服务时，我们如何收集、使用、储存、共享和转让这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。
      </p>
      <p class="txt">
        我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
      </p>
      <p class="txt">
        请您仔细阅读，在需要时，按照本《隐私条款》的指引，作出您认为适当的选择。如果您不同意本政策的内容，将导致我们无法为您提供完整的服务，同时也请您立即停止使用我们的产品和服务。您使用或继续使用我们提供的产品和/或服务，则表示您同意我们按照本政策收集、使用、储存和分享、披露、保护您的个人信息。如对本政策内容有任何疑问、意见或建议，您可通过{{getCompanyName}}提供的各种联系方式与我们联系。
      </p>
      <p class="left-txt">
        第一部分、定义
      </p>
      <p class="txt">
        个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
      </p>
      <p class="txt">
        个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括个人身份信息、银行账号、通信记录和内容、财产信息、交易信息、不满14周岁未成年的个人信息等。
      </p>
      <p class="txt">
        非个人身份信息：指任何与您有关但实际上不可直接或间接辨认您身份的信息，包括以汇集、匿名或化名方式提供的个人信息。您知悉并同意，无法识别出您的个人身份的信息不属于个人信息。
      </p>
      <p class="txt">
        个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
      </p>
      <p class="left-txt">
        第二部分、隐私条款
      </p>
      <p class="txt">
        一、我们收集的信息
      </p>
      <p class="txt">
        二、我们如何储存您的信息
      </p>
      <p class="txt">
        三、我们如何使用收集的信息
      </p>
      <p class="txt">
        四、我们如何共享、公开披露您的信息
      </p>
      <p class="txt">
        五、您如何管理您的信息及您的权利
      </p>
      <p class="txt">
        六、第三方服务
      </p>
      <p class="line"></p>
      <span class="green-btn">一、我们收集的信息</span>
      <p class="left-txt">
        1.1 您向我们提供的信息
      </p>
      <p class="left-small-txt">
        1.1.1 注册
      </p>
      <p class="left-small-txt-two">
        您创建账号或咨询服务时，您需要提供包括手机号码、及密码等在内的数据。如您仅需使用浏览、搜索服务，您不需要注册成为我们的会员及提供上述信息。
      </p>
      <p class="left-small-txt">
        1.1.2 登录
      </p>
      <p class="left-small-txt-two">
        您登录个人账户后，可以进入"我的"自行选择上传、设置、修改或完善相关个人信息，具体包括：个人头像、昵称、真实姓名、学历、登录密码、联系方式、位置信息，收货地址等。
      </p>
      <p class="left-small-txt">
        1.1.3 购课
      </p>
      <p class="left-small-txt-two">
        您在购买我们的产品或服务中准备消费支付时，主动向我们提供的相关个人信息，例如姓名、性别、密码、银行卡号、交易账单信息、配送地址、收货人信息、发票开具信息、备注信息等；如商品系第三方卖家提供的或商品需要第三方配送的，我们为了顺利、安全、准确完成货物的交付及配送，商家及第三方配送公司在发货及配送环节内不可避免地会获知相关配送信息。我们向用户承诺，我们会以最大努力保障个人信息安全，我们会严格要求商家及第三方配送公司对用户的个人信息保密，只以配送之目的获悉和使用，不得对外泄露或做其他任何用途。
      </p>
      <p class="left-small-txt">
        1.1.4 售后
      </p>
      <p class="left-small-txt-two">
        您在使用我们的客服、产品或服务的售后功能时，主动向我们提供的报名登记联系方式之外的联系方式、账户相关信息、交易账单信息、与我方工作人员的沟通记录；您知悉，上传您的个人信息（特别是个人敏感信息）或发布、储存相关信息并非您的义务，但如您拒绝提供，可能会限制我们为您提供更多的服务。
      </p>
      <p class="left-txt">
        1.2 我们在您使用服务过程中收集的信息
      </p>
      <p class="txt2">
        设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（例如IP 地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站等传感器信息）及您所授予的设备权限使用所获信息(例如：为丰富用户使用体验，APP在部分苹果设备上基于TrueDepth APIs通过相机权限获取您面部在世界坐标系的位置，用于实时计算眼睛所注视设备屏幕的位置信息并应用于互动反馈)。如果您在安装及/或使用过程中拒绝授予我们相应权限的，我们并不会记录您上述对应的信息。
      </p>
      <p class="txt2">
        服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如搜索查询内容、课程的观看记录、课程的观看时长、IP地址、浏览器的类型、电信运营商、访问日期和时间及您访问的网页记录等。
      </p>
      <p class="txt2">
        其他相关信息：为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。例如为确保您使用我们服务时能方便地取用您的联系人信息，如您选择允许访问您的通讯录权限，我们可能对您联系人的姓名和电话号码进行加密收集。
      </p>
      <p class="txt2">
        请您理解，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。除非将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，我们会将该类个人信息做匿名化、去标识化处理（已取得您授权或法律法规另有规定的情况除外）。
      </p>
      <p class="txt2">
        当您与我们联系时，为验证您的身份，帮助您解决问题，我们可能会记录您与我们的对话并收集其他为解决问题所需的必要信息。
      </p>
      <p class="left-txt">
        1.3 其他方分享的您的信息
      </p>
      <p class="txt2">
        当您使用我们的关联公司、合作伙伴的服务时，他们在您的授权下可能向我们分享您的相关信息；
      </p>
      <p class="txt2">
        若您以其他方式关联登录、使用我们的服务，我们会向第三方请求您的个人信息，对于我们需要但第三方无法提供的个人信息，我们仍会要求您提供。如果您拒绝提供，将可能导致您无法正常使用我们的服务的某些功能。
      </p>
      <p class="txt2">
        我们将会依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律法规规定的前提下，使用从第三方获得的您的个人信息。
      </p>
      <span class="green-btn">二、 我们如何储存您的信息</span>
      <p class="left-txt">
        2.1 我们在中华人民共和国境内运营中收集和产生的个人信息原则上储存在中国境内，以下情况除外：
      </p>
      <p class="left-small-txt">
        a） 法律法规明确规定；
      </p>

      <p class="left-small-txt">
        b） 获得您的明确授权；
      </p>
      <p class="left-small-txt">
        针对以上情况，我们会确保依据法律法规和《隐私条款》对您的个人信息提供安全保护。
      </p>

      <p class="left-txt">
        2.2 除法律或相关法规另有约定外，我们在为提供我们的服务之目的所必需的期间内保留您的个人信息，但您要求我们立即删除或注销账户的、或法律法规另有规定的除外。对于已匿名化的信息的存储期限和处理，我们无需取得您的授权同意，也无需做出通知。
      </p>
      <span class="green-btn">三、 我们如何使用收集的信息</span>
      <p class="left-txt">
        3.1 我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：
      </p>
      <p class="txt2">
        a）用于数据分析，以便向您介绍、提供更加优质的服务；
      </p>
      <p class="txt2">
        b）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份途，确保我们向您提供的产品和服务的安全性；
      </p>
      <p class="txt2">
        c）帮助我们设计新服务，改善我们现有服务；
      </p>
      <p class="txt2">
        d）使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户作出其他方面的回应；
      </p>
      <p class="txt2">
        e）让您参与有关我们产品和服务或通过我们的产品和服务发起的调查，是否参与调查将由您全权决定，并且由您自行选择提供哪些信息；
      </p>
      <p class="txt2">
        f）出于安全、合法调查等目的，我们可能使用您的数据做数据汇总、分析、挖掘（包括商业化利用），但这些信息都采用匿名的方式，不能识别您的身份。
      </p>
      <p class="left-txt">
        3.2 为了让我们的用户有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过我们的某一项服务所收集的个人信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的您的个人信息，可能在另一服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息。
      </p>
      <p class="left-txt">
        3.3 请您注意，除非您删除或撤回授权（即通过系统设置拒绝我们的收集和使用），您在使用我们的服务时所提供的所有个人信息，将在您使用我们的服务期间持续授权我们在符合本政策的范围内使用。在您注销账号后，我们将根据您的要求删除您的个人信息，或做匿名化处理，但法律法规另有规定的除外。
      </p>
      <span class="green-btn">四、 我们如何共享、公开披露您的信息</span>
      <p class="left-txt">
        4.1 我们可能将上述我们收集的个人信息提供给我们的关联公司、合作伙伴（例如代表我们发送短信通知、推送通知的服务提供商、为我们提供位置数据的地图服务提供商），用于以下用途：
      </p>
      <p class="txt2">
        a）用于数据分析，以便向您介绍、提供更加优质的服务；
      </p>
      <p class="txt2">
        b）实现第三款部分所述目的；
      </p>
      <p class="txt2">
        c）维护和改善我们的产品和/或服务。
      </p>
      <p class="txt2">
        我们会以高度的重视对待您的信息，除上述情形外，未经您的同意，我们不会与任何第三方共享您的信息。
      </p>
      <p class="left-txt">
        4.2 我们还可能以下需求而保留、保存或披露您的个人信息：
      </p>
      <p class="txt2">
        a）遵守相关的法律法规；
      </p>
      <p class="txt2">
        b）遵守司法机关命令或其他法律程序的规定；
      </p>
      <p class="txt2">
        c）遵守相关政府机关的要求。
      </p>
      <span class="green-btn">五、 您如何管理您的信息及您的权利</span>
      <p class="left-txt">
        5.1 访问权
      </p>
      <p class="txt2">
        账号信息：您可以随时登录您的个人账号，访问或编辑您的账号中的个人资料信息、更改您的密码、添加安全信息、进行账号关联或身份认证等；
      </p>
      <p class="txt2">
        使用信息：您可以在我们的网站、客户端等服务中查阅订单信息等，您也可通过本政策文末提供的方式联系我们删除这些信息，我们将在核实您的身份后提供，但法律法规另有约定的除外；
      </p>
      <p class="txt2">
        使用信息：您可以在我们的网站、客户端等服务中查阅订单信息等，您也可通过本政策文末提供的方式联系我们删除这些信息，我们将在核实您的身份后提供，但法律法规另有约定的除外；
      </p>
      <p class="txt2">
        您在我们的网站或客户端发表的评论和其他信息可能被本网站或客户端的其他访问者浏览和下载。为此，我们鼓励您在决定是否在其他参与者可浏览页面上发布可能显示您的身份的任何信息时慎重思考。
      </p>
      <p class="left-txt">
        5.2 更正权
      </p>
      <p class="txt2">
        经对您的身份进行验证，且更正不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或更新，您可以自行在我们的网站或客户端中进行更正，或在特定情况下，尤其是数据错误时，通过本政策文末提供的联系方式联系我们，要求我们更正或更新您的数据，但法律法规另有规定的除外。
      </p>
      <p class="left-txt">
        5.3 撤回同意权
      </p>
      <p class="txt2">
        如您想更改相关功能的授权范围（例如位置、通讯录、相机），您可以通过您的硬件设备修改个人设置、或在我们的产品或服务中的相关功能设置界面进行操作处理。如您在此过程中遇到操作问题的，可以通过本政策文末提供的方式联系我们。
      </p>
      <p class="txt2">
        当您取消相关个人信息收集的授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但您知悉并同意，除非您行使前述"被遗忘权"，否则您的该行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
      </p>
      <p class="left-txt">
        5.4 例外情形
      </p>
      <p class="txt2">
        在以下情形中，按照法律法规要求，我们将无法响应您的请求：
      </p>
      <p class="txt2">
        a） 与国家安全、国防安全直接相关的；
      </p>
      <p class="txt2">
        b） 与公共安全、公共卫生、重大公共利益直接相关的；
      </p>
      <p class="txt2">
        c） 与犯罪侦查、起诉、审判和判决执行等直接相关的；
      </p>
      <p class="txt2">
        d） 有充分证据表明您存在主观恶意或滥用权利的；
      </p>
      <p class="txt2">
        e） 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
      </p>
      <p class="txt2">
        f） 涉及商业秘密的；
      </p>
      <p class="txt2">
        g） 对收集的个人信息已经进行脱敏处理的；
      </p>
      <p class="txt2">
        h） 出于保证用户或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </p>
      <p class="txt2">
        i） 所收集的信息是用户自行向社会公开的或者是从合法公开的渠道中收集到的；
      </p>
      <p class="txt2">
        j） 根据与用户签订和履行相关协议或其他书面文件所必需的；
      </p>
      <p class="txt2">
        k） 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；
      </p>
      <p class="txt2">
        l） 其他法律法规等规定的情形。
      </p>
      <span class="green-btn">六、 第三方服务</span>
      <p class="txt2">
        为了提升为您提供服务的质量，我们会接入优质第三方服务商一起为您提供服务，在提供服务的过程中，我们将基于为您提供服务的目的向第三方服务商披露您必要的个人信息，例如身份认证信息、出勤记录等，也会要求第三方服务商向我们回传您相关的个人信息。如您拒绝授权提供，将可能导致您无法正常使用我们的服务的某些功能。我们会要求第三方遵守同等的保密义务和采取保密措施。
      </p>
      <span class="green-btn">七、 您的信息如何在全球范围转移</span>
      <p class="txt2">
        我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
      </p>
      <p class="txt2">
        1、 适用的法律法规有明确规定；
      </p>
      <p class="txt2">
        2、 获得您的明确授权；
      </p>
      <p class="txt2">
        3、 您通过互联网进行跨境交易等个人主动行为。
      </p>
      <p class="txt2">
        针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。
      </p>
      <p class="txt2">
        l） 其他法律法规等规定的情形。
      </p>
      <p class="txt2">
        l） 其他法律法规等规定的情形。
      </p>
      <span class="green-btn">八、 本隐私条款修订及更新</span>
      <p class="txt2">
        我们可能适时修改本《隐私条款》的条款，该等修改构成本《隐私条款》的一部分。对于重大变更，我们会提供更显著的通知，您可以选择停止使用我们的服务；在该种情况下，如您仍然继续使用我们服务的，即表示同意受经修订的本《隐私条款》的约束。
      </p>
      <p class="txt2">
        我们可能适时修改本《隐私条款》的条款，该等修改构成本《隐私条款》的一部分。对于重大变更，我们会提供更显著的通知，您可以选择停止使用我们的服务；在该种情况下，如您仍然继续使用我们服务的，即表示同意受经修订的本《隐私条款》的约束。
      </p>
      <span class="green-btn">九、 如何联系我们</span>
      <p class="txt2">
        您可以通过以下方式与我们联系，我们会尽快回复您的请求：
      </p>
      <p class="txt2">
        1、 如对本政策内容有任何疑问、意见或建议，您可通过{{getCompanyName}}app及客服与我们联系。联系电话：400-875-3006；
      </p>
      <p class="txt2">
        2、 如发现个人信息可能被泄露，您可以通过意见反馈通道投诉举报。
      </p>
      <p class="txt2">
        如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向{{getCompanyName}}所在地有管辖权的法院提起诉讼来寻求解决方案。
      </p>
    </div>
  </div>
</template>
<script>
import AgreementHeader from './components/header';
import ColumnName from './components/ColumnName';

export default {
  layout: 'empty',
  components: {
    AgreementHeader,
    ColumnName
  },
  // 接收参数
  props: {},
  data () {
    // 这里存放数据
    return {

    };
  },
  computed: {
    getCompanyName () {
      const companyInfo = this.$store.state.companyInfo || {};
      return companyInfo.companyName;
    }
  },
  mounted () {

  },
  // 方法集合
  methods: {

  }
};
</script>
<style lang='less' scoped>
.wrapper {
  background: url("~@/assets/image/agreement/yinsi.png") center top no-repeat;
  background-size: 100% 700px;
  background-attachment: fixed;
}
.txt-box {
  padding: 40px 40px 100px;
  background-color: #fff;
  width: 1220px;
  margin: 0 auto;
  .title {
    color: @main-color;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    padding-bottom: 33px;
  }
  .txt {
    color: #999999;
    text-indent: 35px;
  }
  .txt2 {
    color: #333333;
    text-indent: 35px;
  }
  .line {
    height: 1px;
    width: 100%;
    background: #eeeeee;
    margin: 55px 0;
  }
  .left-txt {
    font-weight: bold;
    margin-top: 20px;
  }
  .left-small-txt {
    color: #333333;
    text-indent: 65px;
  }
  .left-small-txt-two {
    color: #333333;
    text-indent: 85px;
  }
  .green-btn {
    margin-top: 20px;
    display: inline-block;
    background: #08d88a;
    border-radius: 30px;
    padding: 0 15px;
    line-height: 2.2;
    font-size: 16px;
    color: #ffffff;
  }
  p {
    line-height: 2.2;
    font-size: 16px;
  }
}
</style>
